import { getGridStringOperators } from '@mui/x-data-grid-pro';

import { getFilteredOperators } from '../get-filtered-operators';

// Must match: https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/colDef/gridStringOperators.ts
export enum GridStringOperator {
  Contains = 'contains',
  DoesNotContain = 'doesNotContain',
  Equals = 'equals',
  DoesNotEqual = 'doesNotEqual',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  isAnyOf = 'isAnyOf',
}
export const getFilteredGridStringOperators = (
  allowedOperators: GridStringOperator[],
  disableTrim?: boolean,
) =>
  getFilteredOperators(getGridStringOperators(disableTrim), allowedOperators);
